import { ReactNode } from "react"

export interface NonAuthLayoutProps {
  children: ReactNode
}

export function NonAuthLayout({ children }: NonAuthLayoutProps) {
  return <>{children}</>
}
